<template>
    <div class="listOne" v-show="newList.length>0">
        <div v-for="(item,index) in newList" :key="index" class="box-list clearfix" @click="shoDetial(item)">
          <div class="box-list-font fl">
            <div class="title over-one">{{item.article_title}}</div>
            <div class="info over-two"> 
              <div class="info1">
                [时 间]：
              </div>
              <div class="info2">
                {{item.dynamic_data.time}}
              </div>
            </div>
            <div class="info over-two"> 
              <div class="info1">
                [地 点]：
              </div>
              <div class="info2">
                {{item.dynamic_data.address}}
              </div>
            </div>
            <div class="info over-two"> 
              <div class="info1">
                [召集人]：
              </div>
              <div class="info2">
                {{item.dynamic_data.convenor}}
              </div>
            </div>           
          </div>
        </div>
        <div class="page">
             <el-pagination
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-size="pageSize"
                layout="prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        columnId: {
        type: String,
        default: '',
        
        }
    },
  data() {
    return {
      newList:[],
      total:0,
      currentPage:1,
      pageSize:10
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      let self = this
      this.newList = []
      this.$common.noLoginCallUrl('/api/cp-cms/site/info/getInfoPage',{
        column_id:self.columnId,
        pageNo:self.currentPage,
        pageCount:self.pageSize
      },
      function(res){
        if(res.code == '000000'){
            self.newList = res.data.data || []
            self.total = res.data.count
        }else{
            self.$message.warning(res.msg)
        }
      })
    },
    handleSizeChange(){

    },
    handleCurrentChange(item){
        this.currentPage = item
        this.getList()
    },
    shoDetial(item){
        this.$emit('detail',item)
    }
  },
  watch: { // 监听，当路由发生变化的时候执行
    
  }
};
</script>

<style lang="less" scoped>
.listOne{
    .box-list {
        width: 800px;
        margin: 20px auto;
        height: 210px;
        box-sizing: border-box;
        padding: 10px;
        cursor: pointer;
        border-bottom: dashed 1px #dedede;

        .box-list-font {
          width: 800px;
          height: 200px;

          .title {
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 20px;
          }

          .info {
            font-size: 14px;
            height: 30px;
            display: flex;
            .info1{
              color: #888;
              width: 85px;
            }
            .info2{
              
            }
          }
          
        }
      }
      .page{
        text-align: center;
        margin-bottom: 20px;
      }
}
</style>